import { DisabilitiesPtEnum, YieldsOwnership } from '@app/entities/enums/ptrab/irs.enum';

export class WorkerPt {
  civilStatusId!: number;
  civilStatusName?: string;
  disability!: DisabilitiesPtEnum;
  percentage!: number;
  fiscalStatus!: number;
  incomeTitularity!: YieldsOwnership;
}

export class Spouse {
  disability!: DisabilitiesPtEnum;
  percentage!: number;
}

export class Dependant {
  id?: number;
  birthdate!: string;
  disability!: DisabilitiesPtEnum;
  percentage!: number;
}

export class YoungBenefit {
  years!: number;
}

export class IrsModel {
  worker!: WorkerPt;
  spouse!: Spouse;
  dependants!: Dependant[];
  youngBenefit!: YoungBenefit;

  hasYoungBenefit(): boolean {
    return this.youngBenefit && this.youngBenefit.years !== 0;
  }
}

export class IrsWithholdingModel {
  maxRetention!: number;
  voluntaryRetention!: number;
  multiplyFactor!: number;
}
